module.exports = __webpack_public_path__ + "static/media/chevron_left.62067eb6.svg";